import React, { useState, useContext } from 'react';
import ReactPlayer from 'react-player';

import PlayerTitle from './player-title/PlayerTitle';
import VolumeSlider from './volume-slider/VolumeSlider';
import PlaybackSpeed from './playback-speed/PlaybackSpeed';
import PlaybackControls from './playback-controls/PlaybackControls';
import PlayerMinimized from './player-minimized/PlayerMinimized';

import { formatDuration } from '../../utilities/duration';

import { NowPlayingContext } from '../../contexts/now-playing.context';
import { PlayerContext } from '../../contexts/player.context';

import {
  PlayerWrapper,
  Progress,
  ProgressWrapper,
  Range,
  ControlWrapper,
  ProgressBar,
  MinimizeBtn
} from './Player.styles';

const AudioPlayer = () => {
  const { nowPlaying, isPlaying } = useContext(NowPlayingContext);
  const { audio, progress = 0 } = nowPlaying;

  const { volume, playbackRate, minimized } = useContext(PlayerContext);

  const [duration, setDuration] = useState(0);
  const [played, setPlayed] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [audioLoaded, setAudioLoaded] = useState(false);

  let player = React.createRef();

  const handleDuration = duration => {
    setDuration(duration);
  };

  const handleSeekMouseDown = e => {
    setSeeking(true);
  };

  const handleSeekChange = e => {
    player.current.seekTo(parseFloat(e.target.value), 'fraction');
    setPlayed(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = e => {
    setSeeking(false);
    player.current.seekTo(parseFloat(e.target.value), 'fraction');
  };

  const handleProgress = ({ played, playedSeconds }) => {
    // We only want to update time slider if we are not currently seeking
    if (!seeking) {
      setPlayed(played);
    }
    // Store episode progress in local storage
    nowPlaying.progress = playedSeconds;
    localStorage.setItem('lastPlayed', JSON.stringify(nowPlaying));
  };

  const handleJump = seconds => {
    const current = player.current.getCurrentTime();
    player.current.seekTo(current + parseFloat(seconds), 'seconds');
  };

  const handleInitialTime = () => {
    if (!audioLoaded) {
      player.current.seekTo(
        player.current.getCurrentTime() + parseFloat(progress),
        'seconds'
      );
      setAudioLoaded(true);
    }
    return;
  };

  return (
    <PlayerWrapper className="py" minimized={minimized}>
      <MinimizeBtn />
      {minimized ? (
        <PlayerMinimized />
      ) : (
        <>
          <PlayerTitle />

          <ControlWrapper>
            <PlaybackControls handleJump={handleJump} />
            <ProgressWrapper>
              <span className="duration" style={{ justifySelf: 'end' }}>
                {formatDuration(duration * played)}
              </span>
              <ProgressBar>
                <Range
                  type="range"
                  min={0}
                  max={1}
                  step="any"
                  value={played}
                  onMouseDown={handleSeekMouseDown}
                  onChange={handleSeekChange}
                  onMouseUp={handleSeekMouseUp}
                />
                <Progress max={1} value={played} />
              </ProgressBar>
              <span className="left duration">
                -{formatDuration(duration * (1 - played))}
              </span>
            </ProgressWrapper>
            <PlaybackSpeed />
            <VolumeSlider />
          </ControlWrapper>
        </>
      )}

      <ReactPlayer
        style={{ position: 'absolute', left: '-10000px' }}
        ref={player}
        url={audio}
        playing={isPlaying}
        playbackRate={playbackRate}
        volume={volume}
        onDuration={handleDuration}
        onProgress={handleProgress}
        onReady={handleInitialTime}
        config={{
          file: {
            forceAudio: true
          }
        }}
        className="playah"
      />
    </PlayerWrapper>
  );
};

export default AudioPlayer;
